import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./i18n";
import { RTL_LANGS } from "./i18n";
import { initNative } from "./native/capacitor-init";

// RTL support au démarrage
const savedLang = localStorage.getItem("kadmiai_lang") || navigator.language?.split("-")[0] || "fr";
if (RTL_LANGS.includes(savedLang)) document.documentElement.dir = "rtl";
document.documentElement.lang = savedLang;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Initialiser les plugins natifs Capacitor (no-op sur le web)
initNative();
